import { SiteSizeComparisonChart } from './SiteSizeComparisonChart.tsx';
import { SiteSizeVsCostPerSFChartData } from './types.ts';

export const SiteSizeVsCostPerSFChartUnwrapped = ({
  data,
  disableAnimations = false,
  width,
  height,
}: {
  data: SiteSizeVsCostPerSFChartData[];
  disableAnimations?: boolean;
  width?: number;
  height?: number;
}) => (
  <SiteSizeComparisonChart
    data={data}
    comparisonKey="siteCostPerSF"
    name="$ / SF"
    label="$ / Lot SF"
    tickFormatter={(val) => `$${val}.00`}
    tooltipFormatter={(val) => `$${val.toFixed(2)}`}
    disableAnimations={disableAnimations}
    width={width}
    height={height}
  />
);
